import { render, staticRenderFns } from "./SlideItem.vue?vue&type=template&id=5792f851&"
import script from "./SlideItem.vue?vue&type=script&lang=js&"
export * from "./SlideItem.vue?vue&type=script&lang=js&"
import style0 from "./SlideItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports